export default __webpack_public_path__ + "static/media/4.1.5248710f.mp4";